"use client"

import { useState, useEffect } from "react"
import StickyHeader from "./StickyHeader"
import img1 from "../img/img1.png"
import img2 from "../img/img2.png"
import img3 from "../img/img3.png"
import AboutUs from "../components/AboutUs"
import Products from "../components/ProductsSection"
import Distribuitors from "../components/DistributorsSection"
import Contact from "../components/Contacto"

const Main = () => {
  const [currentSlide, setCurrentSlide] = useState(0)

  const slides = [
    {
      id: 1,
      title: "Calidad y durabilidad en tus repuestos",
      image: img1,
    },
    {
      id: 2,
      title: "¡Repuestos 100% originales!",
      image: img2,
    },
    {
      id: 3,
      title: "Todo en repuestos Automotrices e Industriales",
      image: img3,
    },
  ]

  // Auto-advance carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [slides.length])

  const goToSlide = (index) => {
    setCurrentSlide(index)
  }

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
  }

  return (
    <>
      <section className="section-main mb-5">
        <StickyHeader />
        <div className="main-content-wrapper">
        <div>
          <p>
            <br />
            
            <br />
            <br />
          </p>
        </div>
          <div className="carousel-container">
            <div className="carousel-wrapper">
              {slides.map((slide, index) => (
                <div
                  key={slide.id}
                  className={`carousel-slide ${index === currentSlide ? "active" : ""}`}
                  style={{ backgroundImage: `url(${slide.image})` }}
                >
                  <div className="slide-content">
                    <div className="brand-name">Incaprosa</div>
                    <h2 className="slide-title">{slide.title}</h2>
                    <button className="ver-productos-btn">Ver productos</button>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation arrows */}
            <button className="carousel-arrow carousel-arrow-left" onClick={prevSlide}>
              <span className="arroup">&#8249;</span>
              
            </button>
            <button className="carousel-arrow carousel-arrow-right" onClick={nextSlide}>
            <span className="arroup">&#8250;</span>
              
            </button>

            {/* Dots indicator */}
            <div className="carousel-dots">
              {slides.map((_, index) => (
                <button
                  key={index}
                  className={`carousel-dot ${index === currentSlide ? "active" : ""}`}
                  onClick={() => goToSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
        <AboutUs></AboutUs>
        <Products></Products>
        <Distribuitors></Distribuitors>
        <Contact></Contact>
        
      </section>
    </>
  )
}

export default Main
